import { styled } from 'troyfe'

const Block = styled.div`
  flex: 1;
  .user-img {
    margin-top: 20px;
    .user-box {
      display: flex;
      align-items: center;
      padding-left: 136px;
    }
    .star {
      display: inline-block;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
    }
    .img {
      position: relative;
      width: 80px;
      height: 80px;
      margin-left: 24px;
      img {
        border-radius: 60px;
        width: 100%;
        height: 100%;
      }
      &:hover {
        .edit {
          cursor: pointer;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
          transform: scale(1);
          transition: 0.5s linear;
          top: 0;
          z-index: 10;
        }
      }
    }
    .edit {
      position: absolute;
      /* transform: scale(0); */
      width: 80px;
      height: 80px;
      border-radius: 60px;
      text-align: center;
      line-height: 80px;
    }
  }
  .ant-upload-list .ant-upload-list-text {
    display: none;
  }
  .form {
    width: 74%;
    margin: 20px auto;
    input,
    .ant-select-selector {
      height: 48px;
      color: #1b1b1d;
      font-size: 16px;
      font-weight: 500;
    }
    .ant-picker {
      height: 48px;
    }
    .ant-form-item-control-input {
      height: 48px;
      line-height: 48px;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-item {
      line-height: 48px;
      font-size: 18px;
    }
    .ant-select-selection-placeholder {
      line-height: 48px;
    }
    .ant-form-item-label {
      width: 21%;
    }
    .ant-form-item-label > label {
      height: 48px;
      justify-content: end;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .modal {
    text-align: center;
    .modal-handle {
      margin-top: 40px;
      padding-bottom: 40px;
    }
    .modal-cancel,
    .modal-confirm {
      width: 200px;
      height: 52px;
    }
    .modal-confirm {
      margin-left: 40px;
    }
  }
`

export default Block
